import { useMemo } from 'react';

const StepBadge = ({ label, ok }) => (
  <span className="inline-flex items-center gap-1 rounded-lg border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.75)] px-2 py-1 text-xs">
    <span aria-hidden>{ok ? '✅' : '❌'}</span>
    <span>{label}</span>
  </span>
);

export default function OperatorModePalette({ operatorMode }) {
  const {
    isOpen,
    query,
    setQuery,
    selectedIndex,
    setSelectedIndex,
    groupedResults,
    results,
    status,
    validationErrors,
    queryInputRef,
    isGuidedMode,
    setIsGuidedMode,
  } = operatorMode;

  const empty = useMemo(() => results.length === 0, [results.length]);

  if (!isOpen) return null;

  let absoluteIndex = 0;

  return (
    <div className="fixed inset-0 z-[var(--z-modal)] flex items-start justify-center bg-[rgba(var(--shadow),0.65)] px-4 pb-10 pt-[12vh] backdrop-blur" role="dialog" aria-modal="true" aria-label="Modo Operador">
      <div className="w-full max-w-4xl rounded-2xl border border-[rgba(var(--border),0.75)] bg-[rgba(var(--panel),0.94)] shadow-[0_28px_60px_rgba(var(--shadow),0.35)]">
        <div className="border-b border-[rgba(var(--border),0.6)] p-4">
          <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
            <div className="flex flex-wrap gap-2">
              <StepBadge label="Línea" ok={status.linea} />
              <StepBadge label="Remitente" ok={status.remitente} />
              <StepBadge label="Destinatario" ok={status.destinatario} />
              <span className="inline-flex items-center rounded-lg border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.75)] px-2 py-1 text-xs">Remitos: {status.remitos}</span>
            </div>
            <button
              type="button"
              className="rounded-lg border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.75)] px-2 py-1 text-xs focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
              onClick={() => setIsGuidedMode(prev => !prev)}
            >
              {isGuidedMode ? 'Modo guiado' : 'Modo libre'}
            </button>
          </div>

          {validationErrors.length > 0 && (
            <div className="mb-3 rounded-xl border border-[rgba(var(--danger),0.45)] bg-[rgba(var(--danger),0.1)] p-2 text-sm text-[rgb(var(--danger))]">
              {validationErrors.map(error => <p key={error}>• {error}</p>)}
            </div>
          )}

          <input
            ref={queryInputRef}
            value={query}
            onChange={event => setQuery(event.target.value)}
            placeholder="Buscar cliente, línea, remito, acción…"
            className="w-full rounded-xl border border-[rgba(var(--border),0.7)] bg-[rgba(var(--subpanel),0.8)] px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
          />
        </div>

        <div className="max-h-[56vh] overflow-auto p-3">
          {empty ? (
            <p className="rounded-xl border border-[rgba(var(--border),0.5)] p-4 text-sm text-[rgba(var(--muted),0.95)]">Sin resultados para la búsqueda actual.</p>
          ) : (
            groupedResults.map(group => (
              <section key={group.title} className="mb-4">
                <h3 className="mb-2 px-2 text-xs font-semibold uppercase tracking-wide text-[rgba(var(--muted),0.95)]">{group.title}</h3>
                <ul className="space-y-1">
                  {group.items.map(item => {
                    const index = absoluteIndex;
                    absoluteIndex += 1;
                    const selected = selectedIndex === index;
                    return (
                      <li key={item.id}>
                        <button
                          type="button"
                          onMouseEnter={() => setSelectedIndex(index)}
                          onClick={() => operatorMode.selectItem(item)}
                          className={`flex w-full items-start gap-3 rounded-xl border px-3 py-2 text-left transition ${
                            selected
                              ? 'border-[rgba(var(--brand),0.55)] bg-[rgba(var(--brand),0.15)]'
                              : 'border-transparent bg-transparent hover:border-[rgba(var(--border),0.7)] hover:bg-[rgba(var(--subpanel),0.55)]'
                          } focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]`}
                        >
                          <span className="mt-0.5 text-base" aria-hidden>{item.icon || '•'}</span>
                          <span className="min-w-0 flex-1">
                            <span className="block truncate text-sm font-medium">{item.title}</span>
                            <span className="block truncate text-xs text-[rgba(var(--muted),0.95)]">{item.subtitle}</span>
                          </span>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </section>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
